import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslationService } from './core/services/translation.service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from './features/auth/services/auth.service';
import { SignalrService, PaymentNotification } from './shared/services/signalr.service';
import { SystemHealthService } from './shared/services/system-health.service';
import { AnalyticsService } from './core/services/analytics.service';
import { AffiliateTrackingService } from './core/services/affiliate-tracking.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  // Lấy ngôn ngữ hiện tại từ Service (đã bao gồm logic check localStorage bên trong)
  langSeleted: string = this.translationService.getCurrentLang();

  private subscription = new Subscription();
  showFloating: boolean = false;

  constructor(
    private translationService: TranslationService,
    private authService: AuthService,
    private signalrService: SignalrService,
    private router: Router,
    private systemHealth: SystemHealthService,
    private analytics: AnalyticsService,
    private affiliateTracking: AffiliateTrackingService
  ) {
    // Không cần dùng trực tiếp TranslateService ở đây nữa 
    // vì TranslationService đã xử lý setDefaultLang và use trong constructor của nó rồi.
  }

  ngOnInit(): void {
    this.systemHealth.clear();
    
    // Đảm bảo đồng bộ hóa ngôn ngữ ngay khi khởi tạo App
    this.translationService.setLanguage(this.langSeleted);

    // Kiểm tra user ngay khi khởi tạo
    const currentId = this.authService.getCurrentUserId();
    if (currentId) {
      this.analytics.setUserId(currentId);
    }

    // Capture affiliate ref_hash from URL query param and store in cookie (Task 9)
    this.affiliateTracking.captureFromUrl();

    this.checkFloatingVisibility(this.router.url);

    // Track all navigation events (NavigationEnd fires on initial navigation and subsequent route changes)
    this.subscription.add(
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.affiliateTracking.captureFromUrl();
          this.analytics.trackPageVisit(event.urlAfterRedirects).subscribe({
            error: (err) => console.debug('Failed to track page visit:', err)
          });
          this.checkFloatingVisibility(event.urlAfterRedirects);
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private checkFloatingVisibility(url: string) {
    const allowedRoutes = [
      /^\/$/,         // home
        /^\/product$/  // product list + detail
    ];

    this.showFloating = allowedRoutes.some(route =>
      route.test(url)
    );
  }
}